import React from 'react';
import './Home.css';

import image1 from './assets/Box1.png';
import image2 from './assets/APEBNB.png';
import image3 from './assets/REKTY CLOWN.png';
import image4 from './assets/Newspaper.png';

import imageC1 from './assets/neww.png';
import imageC2 from './assets/Write Up Show.png';
import imageC3 from './assets/MILKIE.png';
import imageC4 from './assets/Kodas Eat.png';


import imageR1 from './assets/Cab.png';
import imageR2 from './assets/Monke.png';


import SystemMessage from './SystemMessage';


import Footer from '../Footer';

function App() {
  return (
    <div>
   <div className="containerzd">
      <div className="left-panel">
       <img src={image1} style={{width:"100%"}}/>
       <img src={image2} style={{width:"100%"}}/>
       <img src={image3} style={{width:"100%"}}/>
       <img src={image4} style={{width:"100%"}}/>
      </div>

      <div className="center-panel">
      <img src={imageC1} style={{width:"100%"}}/>
      <img src={imageC2} style={{width:"100%"}}/>
<div className='vertical'>
<img src={imageC3} style={{width:"50%"}}/>
<img src={imageC4} style={{width:"35%"}}/>
</div>

      </div>

      <div className="right-panel">
        <br/>
        <br/>
        <SystemMessage/>
        <br/> <br/> <br/> <br/> <br/> <br/>
      <img src={imageR1} style={{width:"100%"}}/>
      <br/> <br/> <br/>
      <img src={imageR2} style={{width:"100%"}}/>
      </div>



    </div>

<br/>
<br/>
<Footer/>
    </div>
 
  );
}

export default App;
